/**
 * Base class for every API resource (FastApply, Compact, Reflex, …).
 *
 * Mirrors the OpenAI SDK's `APIResource`: a resource holds nothing but a
 * reference to the transport (`MorphAPIClient`) and delegates all HTTP to it.
 * Sub-resources receive the same client by reference, so configuration and the
 * fetch/retry/auth machinery live in exactly one place.
 */
import type { MorphAPIClient } from './client.js';

export abstract class APIResource {
  protected _client: MorphAPIClient;

  constructor(client: MorphAPIClient) {
    this._client = client;
  }
}
